export default {"src":"/app/_next/static/media/3x3.39d9441c.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};